import Debug from 'debug';
import * as React from 'react';
import { General } from './General';
import { getEntity } from '../data/ReduxRoot';
import { Field, ReferenceField } from 'gossamer-unified';

const debug = Debug('gfe/fi/Flex');

export interface Props {
  fieldId: string;
  value: string;
}

export const Flex: React.FC<Props> = (props) => {
  debug(props);
  try {
    const fieldAndValue = JSON.parse(props.value) as Field & { value?: string };
    const value = fieldAndValue.value;
    delete (fieldAndValue as Partial<Field & { value?: string }>).value;
    if (typeof (fieldAndValue as ReferenceField).refEntity === 'string') {
      (fieldAndValue as ReferenceField).refEntity = getEntity(
        (fieldAndValue as ReferenceField).refEntity as unknown as string,
      );
    }
    return <General editable={false} fieldId={props.fieldId} field={fieldAndValue} value={value} />;
  } catch (e) {
    return String(e);
  }
};
